import {
  Award,
  Coins,
  Route,
  Sparkles,
  Target,
  Trophy,
  type LucideIcon
} from 'lucide-react'

import type { MyDataProgress } from '../types'

import { AnimatedNumber } from '@/shared/ui/AnimatedNumber'

type Accent = 'gold' | 'blue' | 'green'

// brand-yellow/gold é reservado a reward/XP/nível/medalha (brandbook). Moedas
// usam o gold da moeda (--warning). Níveis/Título → primary; Desafios → success.
const ACCENT_CLASSES: Record<Accent, string> = {
  gold: 'bg-warning/15 text-warning',
  blue: 'bg-primary/10 text-primary',
  green: 'bg-success/15 text-success'
}

interface StatTileProps {
  icon: LucideIcon
  label: string
  value: number | string
  accent: Accent
}

function StatTile({ icon: Icon, label, value, accent }: StatTileProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-1.5 rounded-2xl border border-border bg-linear-to-t from-[#f2f4ff] to-white p-3 text-center shadow-[0_4px_0_rgba(106,129,219,0.18)]">
      <span
        className={`flex size-8 items-center justify-center rounded-xl ${ACCENT_CLASSES[accent]}`}
      >
        <Icon className="size-4" aria-hidden />
      </span>
      {typeof value === 'number' ? (
        <AnimatedNumber
          value={value}
          className="font-hl text-lg font-extrabold leading-none text-primary-dark"
        />
      ) : (
        <span className="font-hl text-base font-extrabold leading-none text-primary-dark">
          {value}
        </span>
      )}
      <span className="text-[11px] font-semibold leading-tight text-muted-foreground">
        {label}
      </span>
    </div>
  )
}

export function ProgressStatsRow({ progress }: { progress: MyDataProgress }) {
  return (
    <div className="grid grid-cols-3 gap-3 sm:grid-cols-6">
      <StatTile icon={Sparkles} label="Pontos" value={progress.pontos} accent="gold" />
      <StatTile icon={Coins} label="Moedas" value={progress.moedas} accent="gold" />
      <StatTile icon={Award} label="Medalhas" value={progress.medalhas} accent="gold" />
      <StatTile icon={Route} label="Níveis" value={progress.niveis_concluidos} accent="blue" />
      <StatTile
        icon={Target}
        label="Desafios"
        value={progress.desafios_concluidos}
        accent="green"
      />
      <StatTile icon={Trophy} label="Título" value={progress.titulo ?? '—'} accent="blue" />
    </div>
  )
}
